import React, { useState, useEffect } from "react";
import axios from "axios";
import { getCookie, removeCookie, setCookie } from "./cookies";
import { API_POST_MAMBOO } from "services";

const BASE_URL = process.env.REACT_APP_API_URL_SERVER;

const instance = axios.create({});

const AxiosInterceptor = ({ children }) => {
    const [isSet, setIsSet] = useState(false);
    useEffect(() => {
        const reqInterceptor = async (config) => {
            const accessToken = getCookie('auth_token');
            config.headers["Authorization"] = "Bearer " + accessToken;

            return config
        }
        const errInterceptor = (error) => {
            // Error di sini terjadi saat menyusun request, bukan karena
            // autentikasi — jadi sesi tidak boleh diakhiri. `return` juga
            // sebelumnya hilang, sehingga penolakannya tertelan dan pemanggil
            // menerima `undefined` alih-alih error.
            return Promise.reject(error)
        }
        const interceptor = instance.interceptors.request.use(
            reqInterceptor,
            errInterceptor
        );
        return () => instance.interceptors.request.eject(interceptor);
    }, [])

    useEffect(() => {
        const resInterceptor = (response) => {
            return response
        }

        const errInterceptor = async (error) => {
            const { config, response } = error;
            const originalRequest = config;
            // const refreshToken = refresher();
            if (
                response &&
                response.status === 403 &&
                response.data.data === "Invalid Token!" &&
                !originalRequest._retry
            ) {
                originalRequest._retry = true;
                return await API_POST_MAMBOO.actions.refreshToken()
                    .then((response) => {
                        if(response.token) {
                            setCookie('auth_token', response.token);
                            axios.defaults.headers["Authorization"] = `Bearer ${response.token}`;
                            window.location.reload();
                        }
                        return axios(originalRequest);
                    })
            } else {
                // Hanya kegagalan autentikasi yang boleh mengakhiri sesi.
                // Sebelumnya blok ini menghapus token untuk SETIAP error —
                // 400, 404, 500, bahkan gagal jaringan saat offline — sehingga
                // satu kesalahan data di backend membuat user ter-logout dan
                // penyebab aslinya jadi sulit dilacak.
                if (response && (response.status === 401 || response.status === 403)) {
                    removeCookie("auth_token");
                }
                return Promise.reject(error);
            }
        };

        const interceptor = instance.interceptors.response.use(
            resInterceptor,
            errInterceptor
        );
        setIsSet(true)
        return () => instance.interceptors.response.eject(interceptor);
    }, [])

    return isSet && children;
}

export default instance;
export { AxiosInterceptor };